import React, { ChangeEvent, FunctionComponent } from "react";

import { Caption, GridColumnCount, GridGapSize, GridLayout, GridLayoutItem, Layout, SpacingSize } from "@multiweb/reactComponents";
import { LOC_BASIC_CONDITION, LOC_TRANSITION_NAME } from "../../../../locKeys";
import { ITransition, WorkflowEditorProps } from "../../../../types";
import { Edit, Memo } from "../../components";

type TransitionPropertiesTabProps = {
    readonly transition: ITransition;
    readonly updateTransition: (newTransition: ITransition) => void;
} & WorkflowEditorProps;

export const TransitionPropertiesTab: FunctionComponent<TransitionPropertiesTabProps> = ({ hostKey, transition, updateTransition }) => {
    const changeTransitionName = (e: ChangeEvent<HTMLInputElement>) => {
        updateTransition({ ...transition, name: e.target.value });
    };

    const changeTransitionCondition = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateTransition({ ...transition, condition: e.target.value });
    };

    return (
        <Layout spacingSizeHorizontal={SpacingSize.m} spacingSizeTop={SpacingSize.m}>
            <GridLayout columns={GridColumnCount.one} gap={GridGapSize.two}>
                <GridLayoutItem>
                    <Caption locKey={LOC_TRANSITION_NAME} />
                    <Edit maxLength={128} value={transition.name} onChange={changeTransitionName} {...{ hostKey }} />
                </GridLayoutItem>
                <GridLayoutItem>
                    <Caption locKey={LOC_BASIC_CONDITION} />
                    <Memo value={transition.condition} onChange={changeTransitionCondition} {...{ hostKey }} />
                </GridLayoutItem>
            </GridLayout>
        </Layout>
    );
};
